import React, { useMemo } from 'react';

import { Field } from 'formik';

import { NWSelect } from '@components/Gui/NwForm/NwFormItems';

const TransactionLabelsSelector = ({ values, setFieldValue, transactionProperties, onChange, updateTitle }) => {
    const getTransactionLabel = (transactionLabelID) =>
        transactionProperties.labels.find((label) => label.ID === transactionLabelID);

    const getEventName = (values) => {
        if (values.SelectedEvent) {
            if (values.SelectedEvent.Name) {
                return ' for ' + values.SelectedEvent.Name;
            }
            if (values.SelectedEvent.Title) {
                return ' for ' + values.SelectedEvent.Title;
            }
        }
        return '';
    };

    const transactionLabelOptions = useMemo(() => {
        const notDisabled = transactionProperties.labels.filter((l) => !l.Disabled);
        const sorted = notDisabled.sort((a, b) => a.Label.localeCompare(b.Label));
        return sorted.map((transactionLabel) => {
            let label = transactionLabel.Label;
            if (transactionLabel.VatCode) {
                label += ` (${transactionLabel.VatCode})`;
            }
            return { key: transactionLabel.ID, label: label, value: transactionLabel.ID };
        });
    }, [transactionProperties.labels]);

    return (
        <Field
            component={NWSelect}
            label="Label"
            name="TransactionLabelID"
            value={values.TransactionLabelID}
            options={transactionLabelOptions}
            onAfterChange={(value) => {
                const transactionLabel = getTransactionLabel(value);
                if (transactionLabel.TypeQuantityName) {
                    setFieldValue('TypeQuantity', transactionLabel.TypeQuantityName);
                }
                if (transactionLabel.FixedTarif) {
                    setFieldValue('Amount', [values.Amount[0], transactionLabel.TotalFee]);
                }
                if (updateTitle) {
                    setFieldValue('Title', `${transactionLabel.Label}${getEventName(values)}`);
                }
                if (onChange) {
                    onChange(value);
                }
            }}
        />
    );
};

export default TransactionLabelsSelector;
